import { parseRequestError } from '@/common/utilities'
import axios from 'axios'
import { formatDateToYMD } from '@/common/components/datepicker'

interface ApplicationSteps {
  identity: {
    clear: number
    manual: number
    flags: number
  }
  residency: {
    flags: number
    passed: number
  }
  student: {
    flags: number
    students_passed: number
  }
  income: {
    dws: number
    tax_commission: number
    manual: number
    flags: number
  }
}
interface DashboardResponse {
  renewal_student_started: number
  renewal_student_completed: number
  renewal_student_in_progress: number
  renewal_student_withdrawn: number
  new_student_started: number
  new_student_completed: number
  new_student_in_progress: number
  new_student_withdrawn: number
  renewal_application_started: number
  renewal_application_completed: number
  renewal_application_in_progress: number
  renewal_application_withdrawn: number
  renewal_application_flags?: number
  renewal_application_steps?: ApplicationSteps
  new_application_started: number
  new_application_completed: number
  new_application_in_progress: number
  new_application_withdrawn: number
  new_application_flags?: number
  new_application_steps?: ApplicationSteps
}

export type InfoDashboardRequest = {
  start_date?: Date | null
  end_date?: Date | null
}

export const getInfoDashboard = async (
  programId?: number,
  requestBody?: InfoDashboardRequest
): Promise<DashboardResponse> => {
  try {
    const params: {
      date?: string
      end_date?: string
    } = {
      ...(requestBody?.start_date && {
        date: formatDateToYMD(requestBody.start_date),
      }),
      ...(requestBody?.end_date && {
        end_date: formatDateToYMD(requestBody.end_date),
      }),
    }
    const response = await axios.get(
      `/applications_students_count_temp?program_id=${programId}`,
      { params }
    )
    return response.data
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}
